<template>
<div class="admin-page-content">
    <div class="container-fluid xyz">
        <div class="admin-page-content">
            <div class="error-detail-main forms-container">
                <!-- <div class="page-header-top-container">
                </div> -->

                <div class="admin-page-content order-form">
                    <!-- <form id="fetchInfoForm"> -->
                        <div class="row justify-content-center" id="orderId">
                            <div class="col-md-3 forms-block">
                                <label for="title">Order ID#</label>
                                <div class="requiredstar">*</div>
                                <input v-model="orderId" type="text" class="form-control" id="orderId" placeholder="Order#" autocomplete="off">
                                <font class="text-danger">{{orderIdError}}</font>
                            </div>

                            <div class="col-md-2 order-btn-container">
                                <input id="orderIdBtn" type="submit" value="Get Order Info" class="btn btn-primary" v-on:click.prevent="getOrderDetail(0)" :disabled="disableorderIdBtn">
                            </div>

                            <div class="col-md-3 forms-block">
                                <label for="customer">Customer ID#</label>
                                <div class="requiredstar">*</div>
                                <input v-model="cusId" type="text" class="form-control" id="orderId" placeholder="Customer Id" autocomplete="off">
                                <!-- <font class="text-danger">{{orderIdError}}</font> -->
                            </div>
                            
                            <div class="col-md-2 order-btn-container">
                                <input id="orderIdBtn" type="submit" value="Check" class="btn btn-primary" v-on:click.prevent="getCustomerDetail(false)" :disabled="disableorderIdBtn">
                            </div>
                            
                        </div>

                    <!-- </form> -->
                    <div class="forms-container row" id="formContainer">
                        <div class="col-md-6" id="orderForm">
                            <div class="page-header-bottom-container">
                            <h3>Order Details</h3>
                            </div>
                                    <div class="row" style="border-right: solid 1px gray;">
                                        <div class="col-md-6 form-group form-bottom-set">
                                            <!-- <div class="col-3 paddingleft0"> -->
                                                <label class="form-label" for="customerId">Customer Id</label>
                                                <!-- <div class="requiredstar">*</div> -->
                                            <!-- </div> -->
                                            <!-- <div class="col-9 paddingleft0"> -->
                                                <input v-model="customerId" type="text" class="form-control" id="customerId" placeholder="Customer Id" :disabled=true>
                                                <font class="text-danger">{{customerIdError}}</font>
                                            <!-- </div> -->
                                        </div>
                                        <!--CustomerName-->
                                        <div class="col-md-6 form-group form-bottom-set">
                                            <label class="form-label" for="email">Customer Name</label>
                                            <!-- <div class="fake-input"> -->
                                                <input v-model="CustomerName" type="text" class="form-control" id="customerName" placeholder="Customer Name" :disabled=true>
                                                <!-- <img v-show="CustomerName" src="/static/images/Group3@2x.png" width=20 />
                                            </div> -->
                                        </div>
                                        <!--Main Phone-->
                                        <div class="col-md-6 form-group form-bottom-set">
                                            <!-- <div class="col-3 paddingleft0"> -->
                                                <label class="form-label" for="mainPhone">Main Phone</label>
                                                <div class="requiredstar">*</div>
                                            <!-- </div> -->
                                            <!-- <div class="col-9 paddingleft0"> -->
                                            <div class="fake-input">
                                                <input v-model="mainPhone" type="text" class="form-control" id="mainPhone" placeholder="Main Phone" :disabled=isDisable>
                                                <img v-show="!mainPhoneError && mainPhone" src="/static/images/Group3@2x.png" width=20 />
                                            </div>
                                                <font class="text-danger">{{mainPhoneError}}</font>
                                            <!-- </div> -->
                                        </div>
                                        <!--Email-->
                                        <div class="col-md-6 form-group form-bottom-set">
                                            <!-- <div class="col-3 paddingleft0"> -->
                                                <label class="form-label" for="email">Email :</label>
                                                <div class="requiredstar">*</div>
                                            <!-- </div>
                                            <div class="col-9 paddingleft0"> -->
                                            <div class="fake-input">
                                                <input v-model="email" type="text" class="form-control" id="email" placeholder="Email" :disabled=isDisable>
                                                <img v-show="!emailError && email" src="/static/images/Group3@2x.png" width=20 />
                                            </div>
                                                <font class="text-danger">{{emailError}}</font>
                                            <!-- </div> -->
                                        </div>
                                        
                                        <!--Branch Id-->
                                        <div class="col-md-6 form-group form-bottom-set">
                                            <!-- <div class="col-3 paddingleft0"> -->
                                                <label class="form-label" for="branchId">Branch Id</label>
                                                <!-- <div class="requiredstar">*</div> -->
                                            <!-- </div> -->
                                            <!-- <div class="col-9 paddingleft0"> -->
                                                <input v-model="branchId" type="text" class="form-control" id="branchId" placeholder="Branch Id" :disabled=true>
                                                <font class="text-danger">{{branchIdError}}</font>
                                            <!-- </div> -->
                                        </div>
                                        <!--Customer Id-->
                                        
                                        <!--Order Amt-->
                                        <div class="col-md-6 form-group form-bottom-set">
                                            <!-- <div class="col-3 paddingleft0"> -->
                                                <label class="form-label" for="orderAmt">Order Amount </label>
                                                <!-- <div class="requiredstar">*</div> -->
                                            <!-- </div>
                                            <div class="col-9 paddingleft0"> -->
                                                <input v-model="orderAmtDisplay" type="text" class="form-control" id="orderAmt" placeholder="Order Amt" :disabled=true>
                                                <font class="text-danger">{{orderAmtError}}</font>
                                            <!-- </div> -->
                                        </div>


                                        <!--Order Status-->
                                        <div class="col-md-6 forms-block form-bottom-set">
                                            <div class="col-md-12 paddingleft0">
                                                <div class="form-label" for="email">
                                                    Form Status : {{ formStatusName }}
                                                    <input v-if="formStatusId > 3 && formStatusId < 8" id="viewBtn" type="button" value="View" class="btn btn-primary" v-on:click.prevent="viewCardDetails()">
                                                </div>

                                            </div>
                                        </div>
                                        <!--Order Status-->
                                        <div class="col-md-6 forms-block form-bottom-set">
                                            <div class="col-md-12 paddingleft0">
                                                <div class="form-label" for="email">Status Date : {{ formStatusDt }}</div>
                                            </div>
                                            <!--div class="col-md-9 paddingleft0">
                                            <div class="form-label" for="email">{{ formStatusDt }}</div>
                                            </div-->
                                        </div>
                                        <!--Creator User-->
                                        <div class="col-md-6 forms-block form-bottom-set">
                                            <div class="col-md-12 paddingleft0">
                                                <div class="form-label" for="email">Created by : {{ creator }}</div>
                                            </div>
                                            <!--div class="col-md-9 paddingleft0">
                                            <div class="form-label" for="email">{{ creator }}</div>
                                            </div-->
                                        </div>
                                        <!--Created at-->
                                        <div class="col-md-6 forms-block form-bottom-set">
                                            <div class="col-md-12 paddingleft0">
                                                <div class="form-label" for="email">Created : {{ created_at }}</div>
                                            </div>
                                            <!--div class="col-md-9 paddingleft0">
                                            <div class="form-label" for="email">{{ created_at }}</div>
                                            </div-->
                                        </div>
                                        <!--Modified User-->
                                        <div class="col-md-6 forms-block form-bottom-set">
                                            <div class="col-md-12 paddingleft0">
                                                <div class="form-label" for="email">Modified by : {{ modified }}</div>
                                            </div>
                                            <!--div class="col-md-9 paddingleft0">
                                            <div class="form-label" for="email">{{ modified }}</div>
                                            </div-->
                                        </div>
                                        <!--Modified Date-->
                                        <div class="col-md-6 forms-block form-bottom-set">
                                            <div class="col-md-12 paddingleft0">
                                                <div class="form-label" for="email">Modified : {{ modified_at }}</div>
                                            </div>
                                            <!--div class="col-md-9 paddingleft0">
                                            <div class="form-label" for="email">{{ modified_at }}</div>
                                            </div-->
                                        </div>

                                        <!--Buttons-->
                                        <div class="col-md-12">
                                            <div class="text-left mt-4 order-footerbtn">
                                                <input id="saveBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addOrderRequest('OPEN')">
                                                <input id="submitBtn" type="submit" value="Submit" class="btn btn-primary ml-1" v-on:click.prevent="addOrderRequest('REDY')">
                                                <!-- If the form status is Void then display New -->
                                                <template v-if="formStatusId == 8">
                                                    <input id="newBtn" type="submit" value="New" class="btn btn-primary ml-1" v-on:click.prevent="getOrderDetail(1)">
                                                </template>
                                                <template v-else>
                                                    <template v-if="formStatusId != 1">
                                                        <input id="voidBtn" type="submit" value="Void" class="btn btn-primary ml-1" v-on:click.prevent="addOrderRequest('VOID')">
                                                    </template>
                                                </template>
                                                <input id="Cancelbtn" type="submit" value="Close" class="back_button btn btn-primary ml-1" v-on:click.prevent="cancelOrderDetailForm()">
                                            </div>
                                        </div>

                                    </div>
                            </div>

                        <div :class="submitOrderId? 'col-md-6 customer-details' : 'col-md-12 customer-details'" id="noCustomerDataFound" >
                            <div class="page-header-bottom-container">
                            <h3>Customer Profile Details</h3>
                            </div>
                            <div style="text-align:center;">
                                <p>{{customerMessage}}</p>
                            </div>
                        </div>

                        <div :class="submitOrderId? 'col-md-6 customer-details' : 'col-md-12 customer-details'" id="noDataOrderForm">
                            <div class="page-header-bottom-container">
                                <h3>Customer Profile Details</h3>
                            </div>
                            <div class="accordion" role="tablist">
                                
                                    <b-card-header header-tag="header" role="tab">
                                        <label class="col-md-2 bold" for="customerType">Card Type</label>
                                        <label class="col-md-2 bold" for="last$digit">Last 4 Digit</label>
                                        <label class="col-md-2 bold" for="Expiry">Expiry</label>
                                        <label class="col-md-2 bold" for="profileHead">Entity</label>
                                        <label class="col-md-3 bold" style="display:inline" for="chargingPassword">Password</label>
                                        </b-card-header>
                                <template v-for="(customer, index) in customerDetails">
                                    <b-card :key="'b-card' + index" no-body>
                                        <b-card-header header-tag="header" style="padding: 0;" role="tab">
                                            <b-button block v-b-toggle="'accordion-' + index" variant="info" style="border-color: white; background-color: #ddd;">
                                                <div class="col-md-2 form-group form-bottom-set" style=" color:#444444; display: inline-block; float: left;"> 
                                                    {{customer.CardType}}
                                                </div>
                                                <div class="col-md-2 form-group form-bottom-set" style="color:#444444; display: inline-block; float: left;">
                                                    {{encryptAccNum(customer.AccountNumber)}}
                                                </div>
                                                <div class="col-md-2 form-group form-bottom-set" style="color:#444444; display: inline-block; float: left;">
                                                    {{getExpiryMonthandYear(customer.CardExpMonth, customer.CardExpYear)}}
                                                </div>
                                                <div class="col-md-2 form-group form-bottom-set" style=" color:#444444; display: inline-block; float: left;"> 
                                                    {{customer.ProfileHead}}
                                                </div>
                                                <div class="col-md-3 form-group form-bottom-set" style="color:#444444; display: inline-block; float: left;">
                                                    {{customer.CardChargingPassword}}
                                                </div>
                                                <div class="col-md-1 form-group form-bottom-set" style="color:#444444; display: inline-block; float: right;">
                                                    <i aria-hidden="true" class="fa fa-angle-up" style="font-size:32px"></i>
                                                </div>
                                            </b-button>
                                        </b-card-header>
                                        <b-collapse class="row" :id="'accordion-' + index" visible accordion="my-accordion" role="tabpanel">
                                            <b-card-body class="row">
                                                    <!-- ProfileID -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Profile Id</label>
                                                    <input v-model="customer.ProfileID" type="text" class="form-control" id="ProfileID" placeholder="Profile Id" :disabled=true>
                                                </div> -->

                                                <!-- CustomerID -->
                                                <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Customer Id</label>
                                                    <input v-model="customer.CustomerID" type="text" class="form-control" id="CustomerID" placeholder="Customer Id" :disabled=true>
                                                </div>

                                                <!-- CustomerRefNum -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Customer Ref Name</label>
                                                    <input v-model="customer.CustomerRefNum" type="text" class="form-control" id="CustomerRefNum" placeholder="Customer Ref Name" :disabled=true>
                                                </div> -->

                                                <!-- CustomerName -->
                                                <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Customer Name</label>
                                                    <input v-model="customer.CustomerName" type="text" class="form-control" id="CustomerName" placeholder="Customer Name" :disabled=true>
                                                </div>

                                                <!-- ProfileHead -->
                                                <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="profileHead">Profile Head</label>
                                                    <input v-model="customer.ProfileHead" type="text" class="form-control" id="ProfileHead" placeholder="Profile Head" :disabled=true>
                                                </div>

                                                <!-- FirstName -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">First Name</label>
                                                    <input v-model="customer.FirstName" type="text" class="form-control" id="FirstName" placeholder="First Name" :disabled=true>
                                                </div> -->

                                                <!-- LastName -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Last Name</label>
                                                    <input v-model="customer.LastName" type="text" class="form-control" id="LastName" placeholder="Last Name" :disabled=true>
                                                </div> -->

                                                <!-- BillName -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Bill Name</label>
                                                    <input v-model="customer.BillName" type="text" class="form-control" id="BillName" placeholder="Bill Name" :disabled=true>
                                                </div> -->

                                                <!-- BillAddress1 -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Bill Address 1</label>
                                                    <input v-model="customer.BillAddress1" type="text" class="form-control" id="BillAddress1" placeholder="Bill Address 1" :disabled=true>
                                                </div> -->

                                                <!-- BillAddress2 -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Bill Address 2</label>
                                                    <input v-model="customer.BillAddress2" type="text" class="form-control" id="BillAddress2" placeholder="Bill Address 2" :disabled=true>
                                                </div> -->

                                                <!-- BillCity -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Bill City</label>
                                                    <input v-model="customer.BillCity" type="text" class="form-control" id="BillCity" placeholder="Bill City" :disabled=true>
                                                </div> -->

                                                <!-- BillState -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Bill State</label>
                                                    <input v-model="customer.BillState" type="text" class="form-control" id="BillState" placeholder="Bill State" :disabled=true>
                                                </div> -->

                                                <!-- BillZipCode -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Bill Zip Code</label>
                                                    <input v-model="customer.BillZipCode" type="text" class="form-control" id="BillZipCode" placeholder="Bill Zip Code" :disabled=true>
                                                </div> -->

                                                <!-- BillCountryCode -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Bill Country Code</label>
                                                    <input v-model="customer.BillCountryCode" type="text" class="form-control" id="BillCountryCode" placeholder="Bill Country Code" :disabled=true>
                                                </div> -->

                                                <!-- Email -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Email</label>
                                                    <input v-model="customer.Email" type="text" class="form-control" id="Email" placeholder="Email" :disabled=true>
                                                </div> -->

                                                <!-- Email_2 -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Email 2</label>
                                                    <input v-model="customer.Email_2" type="text" class="form-control" id="Email_2" placeholder="Email 2" :disabled=true>
                                                </div> -->

                                                <!-- Email_3 -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Email 3</label>
                                                    <input v-model="customer.Email_3" type="text" class="form-control" id="Email_3" placeholder="Email 3" :disabled=true>
                                                </div> -->

                                                <!-- MainPhone -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Main Number</label>
                                                    <input v-model="customer.MainPhone" type="text" class="form-control" id="MainPhone" placeholder="Main Number" :disabled=true>
                                                </div> -->

                                                <!-- OtherPhone -->
                                                <!-- <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Other Phone</label>
                                                    <input v-model="customer.OtherPhone" type="text" class="form-control" id="OtherPhone" placeholder="Other Phone" :disabled=true>
                                                </div> -->

                                                <!-- CardType -->
                                                <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Card Type</label>
                                                    <input v-model="customer.CardType" type="text" class="form-control" id="CardType" placeholder="Card Type" :disabled=true>
                                                </div>

                                                <!-- AccountNumber -->
                                                <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Last 4 digit of Account Number</label>
                                                    <input :value="encryptAccNum(customer.AccountNumber)" type="text" class="form-control" id="AccountNumber" placeholder="Customer Id" :disabled=true>
                                                </div>

                                                <!-- CardExpMonth -->
                                                <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Card Exp Month</label>
                                                    <input v-model="customer.CardExpMonth" type="text" class="form-control" id="CardExpMonth" placeholder="Card Exp Month" :disabled=true>
                                                </div>

                                                <!-- CardExpYear -->
                                                <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Card Exp Year</label>
                                                    <input v-model="customer.CardExpYear" type="text" class="form-control" id="CardExpYear" placeholder="Card Exp Year" :disabled=true>
                                                </div>

                                                <!-- Notes -->
                                                <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Notes</label>
                                                    <input v-model="customer.Notes" type="text" class="form-control" id="Notes" placeholder="Notes" :disabled=true>
                                                </div>

                                                <!-- CardChargingPassword -->
                                                <div class="col-md-6 form-group form-bottom-set">
                                                    <label class="form-label" for="customerId">Card Charging Password</label>
                                                    <input v-model="customer.CardChargingPassword" type="text" class="form-control" id="CardChargingPassword" placeholder="Card Charging Password" :disabled=true>
                                                </div>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>
                                    <!-- <div :key="'div' +index" class="row clearfix"></div> -->
                                </template>
                            </div>
                        </div>
                    </div>

                    <div id="changePass">
                        <div class="col-md-5 forms-block">
                            <div class="col-md-3 paddingleft0">
                                <div class="form-label" for="newPass">New Password :</div>
                            </div>
                            <div class="col-md-9 paddingleft0">
                                <input v-model="newPass" type="password" class="form-control" id="newPass" placeholder="New Password">
                                <div class="requiredstar">*</div>
                                <font class="text-danger">{{newPassError}}</font>
                            </div>
                        </div>
                        <!--Last Name-->
                        <div class="col-md-5 forms-block">
                            <div class="col-md-3 paddingleft0">
                                <div class="form-label" for="confPass">Confirm Password :</div>
                            </div>
                            <div class="col-md-9 paddingleft0">
                                <input v-model="confPass" type="password" class="form-control" id="confPass" placeholder="Confirm Password">
                                <div class="requiredstar">*</div>
                                <font class="text-danger">{{confPassError}}</font>
                            </div>
                        </div>

                        <div class="col-md-2 forms-block">
                            <input id="changePasswordBtn" type="submit" value="Submit" class="btn btn-primary" v-on:click.prevent="changePassword()" :disabled="disableButtons">
                        </div>
                    </div>

                    <div class="help is-danger row justify-content-center"> 
                        <div v-html="error_msg_login"></div>
                        <template v-if="orderResult == 4">
                            <div class="col-md-6 form-group form-bottom-set">
                                <label class="form-label" for="email">Enter customer email below to send the COD account request form to customer: </label>
                                <div class="requiredstar">*</div>
                                <div class="fake-input">
                                    <input v-model="emailCashCustomer" type="email" class="form-control" id="email" placeholder="Email">
                                    <img v-show="!emailCashCustomerError && email" src="/static/images/Group3@2x.png" width=20 />
                                </div>
                                <font class="text-danger">{{emailError}}</font>
                                <br/>
                                <input id="cashCustomerButton" type="button" value="Send Email" class="btn btn-primary ml-1" v-on:click.prevent="sendCashCustomerEmail()">
                            </div>
                        </template>
                    </div>

                </div>
            </div>

        </div>
    </div>
    <app-footer></app-footer>
</div>
</template>

<script>
var self;
import Vue from 'vue';
import Footer from '@/components/partials/Footer';
import EventBus from '.././event-bus';
import {
    commonMixins
} from '../../mixins/commonMixins';
import NoAccessPermission from '@/components/AccessDenied/NoAccessPermission';
import {
    HTTP
} from '../../http-common';

export default {
    name: 'Dashboard',
    components: {
        'app-footer': Footer,
        "no-permission": NoAccessPermission,
    },
    mixins: [commonMixins],
    data() {
        return {
            submitOrderId: "",
            customerDetails: [],
            customerMessage: '',
            ProfileID:'',
            CustomerID:"",
            CustomerRefNum:"",
            cusName:"",
            FirstName:"",
            LastName:"",
            BillName:"",
            BillAddress1:"",
            BillAddress2:"",
            BillCity:"",
            BillState:"",
            BillZipCode:"",
            BillCountryCode:"",
            Email:"",
            Email_2:"",
            Email_3:"",
            MainPhone:"",
            OtherPhone:"",
            CardType:"",
            AccountNumber:"",
            CardExpMonth:"",
            CardExpYear:"",
            Notes:"",
            // DateCreated:{"date":"2022-03-31 00:00:00.000000","timezone_type":3,"timezone":"UTC"},
            CardChargingPassword:"",

            cusId:"",
            CustomerName: "",
            formStatusId: "",
            formStatus: "",
            formStatusName: "",
            formStatusDt: "",
            creator: "",
            created_at: "",
            modified: "",
            modified_at: "",
            reSubmitFlag: 0,


            orderId: "",
            orderIdError: "",
            newPass: "",
            newPassError: "",
            confPass: "",
            confPassError: "",
            disableButtons: false,
            disableorderIdBtn: false,
            error_msg_login: "",
            userId: 0,
            userName: '',

            email: "",
            emailError: "",
            mainPhone: "",
            mainPhoneError: "",
            branchId: "",
            branchIdError: "",
            ccAuthFormId: "",
            ccAuthFormIdError: "",
            customerId: "",
            customerIdError: "",
            orderAmt: "",
            orderAmtTax: 0.00,
            orderAmtDisplay: "",
            orderAmtError: "",
            NewRequestFlag: "",

            // HIDE
            BillCusId: "",
            AccountType: "",
            OrderAmtEstimateFlag: "",
            InvoiceSlsId: "",

            isDisable: false,

            orderResult: 0,
            emailCashCustomer: "",
            emailCashCustomerError: "",
        }
    },
    beforeMount: function () {
        self = this;
    },
    watch: {
      mainPhone: function(mainPhone) {
        self.mainPhone = self.phoneValidate(mainPhone);
      },
      email: function(email) {
        if(email === null || email === "") {
          self.emailError = '';
        } else {
          if (!self.validEmail(email)) {
            self.emailError = 'Please Enter Valid Email';
          } else {
            self.emailError = '';
          }
        }
      },
    },
    mounted: function () {
        
        if (!self.checkLocalStorage('/order')) {
            localStorage.clear();
            self.$router.push("/");
        }
        var passChange = localStorage.getItem('passWordChangeRequiredFlag');
        if (passChange != null && passChange !== "" && passChange !== "0") {
            $('#orderId').hide();
        } else {
            $('#changePass').hide();
        }

        $('#formContainer').hide();
        $('#orderForm').hide();
        $('#noDataOrderForm').hide();
        $('#noCustomerDataFound').hide();
        $('#voidBtn').hide();

        self.userId = localStorage.getItem('user_id');
        if (self.userId == null && self.userId === "" && self.userId === "0") {
          localStorage.clear();
          self.$router.push("/");

        }
        self.userName = localStorage.getItem('user_name');
        self.isLogin = true;

        console.log(self.isLogin);
    },
    methods: {
        changePassword: function () {
            var error = false;
            self.newPassError = '';
            self.confPassError = '';
            if (!self.newPass || self.newPass == null || self.newPass == "") {
                self.newPassError = "The password field is required.";
                error = true;
            } else if(self.newPass.length < 6) {
                self.newPassError = "The password must be at least 6 characters long.";
                error = true;
            }

            if (!self.confPass || self.confPass == null || self.confPass == "") {
                self.confPassError = "The password field is required.";
                error = true;
            }

            if (self.newPass !== "" && self.confPass !== "") {

                if (self.newPass !== self.confPass) {
                    self.confPassError = "Confirm password mismatch";
                    error = true;
                }

            }

            if (!error) {
                self.showLoader();
                self.changePasswordBtn = "Submitting...";
                self.disableButtons = true;

                var fields = {
                    newPass: self.newPass,
                    userId: self.userName
                };

                HTTP.post("change_password", fields)
                    .then(function (data) {
                        console.log(data);
                        self.changePasswordBtn = "Submit";
                        self.disableButtons = false;
                        self.hideLoader();
                        if (data.status == 200) {
                            self.$swal('Change Password', 'Your password change successfully, please login with new password', 'success');
                            localStorage.clear();
                            self.$router.push("/");
                        } else {
                            self.error_msg_login = data.data.message;
                        }
                    })
                    .catch(function (error) {
                        self.error_msg_login = "";
                        self.changePasswordBtn = "Submit";
                        self.disableButtons = false;
                        self.hideLoader();
                        /*$('#loginbtn').text("Login");
                        $("#loginbtn").attr("disabled", false);*/
                        if (error.response.status == 0) {
                            self.error_msg_login = "Remote server can not be reachable";
                        } else {
                            if (error.response.data.message) {
                                self.error_msg_login = error.response.data.message;
                            }
                        }
                    })
            }

        },
        getCustomerDetail(flag) {
            self.submitOrderId = '';
            if(flag){
                console.log(self.orderId);
                if(self.orderId){
                    self.submitOrderId = self.orderId;
                }
            }
            else {
                self.orderId = '';
            }
            
            var error = false;
            self.customerDetails = [];
            self.orderResult = 0;
            self.error_msg_login = "";
            $('#noDataOrderForm').hide();
            $('#noCustomerDataFound').hide();
            if(!self.orderId){
                $('#formContainer').hide();
                $('#orderForm').hide();
            }
            var fields = {
                    customerId: self.cusId,
                };
            self.showLoader();
            HTTP.post("get/customer", fields)
                    .then(function (data) {
                        self.hideLoader();
                        self.orderIdBtn = "Submit";
                        self.disableorderIdBtn = false;
                        
                        if (data.data.code == 200) {
                            self.customerDetails = data.data.content;

                            // console.log(data.data.content.ProfileID);
                            // self.ProfileID = data.data.content.ProfileID,
                            // self.CustomerID = data.data.content.CustomerID,
                            // self.CustomerRefNum = data.data.content.CustomerRefNum,
                            // self.cusName = data.data.content.CustomerName,
                            // self.FirstName = data.data.content.FirstName,
                            // self.LastName = data.data.content.LastName,
                            // self.BillName = data.data.content.BillName,
                            // self.BillAddress1 = data.data.content.BillAddress1,
                            // self.BillAddress2 = data.data.content.BillAddress2,
                            // self.BillCity = data.data.content.BillCity,
                            // self.BillState = data.data.content.BillState,
                            // self.BillZipCode = data.data.content.BillZipCode,
                            // self.BillCountryCode = data.data.content.BillCountryCode,
                            // self.Email = data.data.content.Email,
                            // self.Email_2 = data.data.content.Email_2,
                            // self.Email_3 = data.data.content.Email_3,
                            // self.MainPhone = data.data.content.MainPhone,
                            // self.OtherPhone = data.data.content.OtherPhone,
                            // self.CardType = data.data.content.CardType,
                            // self.AccountNumber = data.data.content.AccountNumber,
                            // self.CardExpMonth = data.data.content.CardExpMonth,
                            // self.CardExpYear = data.data.content.CardExpYear,
                            // self.Notes = data.data.content.Notes,
                            // // DateCreated:{"date":"2022-03-31 00:00:00.000000","timezone_type":3,"timezone":"UTC"},
                            // self.CardChargingPassword = data.data.content.CardChargingPassword;
                            $('#formContainer').show();
                            $('#noDataOrderForm').show();
                        } else if(data.data.code == 201){
                            self.customerMessage = data.data.message;
                            $('#noCustomerDataFound').show();
                        }
                        self.hideLoader();
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.hideLoader();
                        // $('#noDataOrderForm').hide();
                        $('#noCustomerDataFound').hide();
                        
                        self.error_msg_login = "";
                        self.orderIdBtn = "Submit";
                        self.disableorderIdBtn = false;
                        /*$('#loginbtn').text("Login");
                        $("#loginbtn").attr("disabled", false);*/
                        if (error.response.status == 0) {
                            self.error_msg_login = "Remote server can not be reachable";
                        } else {
                            if (error.response.data.message) {
                                self.error_msg_login = error.response.data.message;
                            }
                        }
                    })
        },
        viewCardDetails() {
            window.open(process.env.FRONT_URL + 'form?id=' + this.ccAuthFormId + '&internal=true', '_blank');
        },
        getExpiryMonthandYear: function (month, year){
            return month+"/"+year;
        },
        encryptAccNum: function (AccountNumber) {
            if(AccountNumber){
                var trailingCharsIntactCount = 4;
                AccountNumber = /* new Array(AccountNumber.length - trailingCharsIntactCount + 1).join('x')
                    + */ AccountNumber.slice(-trailingCharsIntactCount);
                    return AccountNumber;
            }
        },
        getOrderDetail: function (retrieveMode) {
            self.submitOrderId = self.orderId;
            var error = false;
            self.error_msg_login = "";
            self.emailError = "";
            self.mainPhoneError = "";
            self.orderIdError = '';
            
            $('#formContainer').hide();
            $('#orderForm').hide();
            // $('#noDataOrderForm').hide();
            // $('#noCustomerDataFound').hide();

            if (!self.orderId || self.orderId == null || self.orderId == "") {
                self.orderIdError = "The Order Id is required.";
                error = true;
            }

            if (!error) {
                var strOrderId = self.orderId;
                strOrderId = strOrderId.toLowerCase();
                /**
                * Reset self.cusId field to avoid confusion in case of data does not load from backend and the previous cusid remain visible
                */
                self.cusId = "";
                self.showLoader();
                self.orderIdBtn = "Submitting...";
                self.disableorderIdBtn = true;

                var fields = {
                    orderId: self.orderId,
                    userId: self.userId,
                    retrieveMode: retrieveMode
                };

                HTTP.post("get/order", fields)
                    .then(function (data) {
                        self.hideLoader();
                        self.orderIdBtn = "Submit";
                        self.disableorderIdBtn = false;


                        const formatter = new Intl.NumberFormat('en-US', {
                                                style: 'currency',
                                                currency: 'USD',
                                                minimumFractionDigits: 2
                                              });


                        if (data.data.code == 200) {
                            self.isCustomerFormViewAllowed = data.data.content.AllowViewCustomerForm;
                            self.email = data.data.content.Email;
                            self.mainPhone = data.data.content.MainPhone;
                            self.branchId = data.data.content.BranchId;
                            self.ccAuthFormId = data.data.content.CCAuthFormId;
                            self.customerId = data.data.content.CustomerId;
                            self.orderAmt = data.data.content.OrderAmt;
                            self.orderAmtTax = data.data.content.OrderAmtTax;
                            self.orderAmtDisplay = formatter.format(data.data.content.OrderAmt);// self.formatPrice(data.data.content.OrderAmt);
                            self.NewRequestFlag = data.data.content.NewRequestFlag;
                            self.BillCusId = data.data.content.BillCusId;
                            self.AccountType = data.data.content.AccountType;
                            self.OrderAmtEstimateFlag = data.data.content.OrderAmtEstimateFlag;
                            self.InvoiceSlsId = data.data.content.InvoiceSlsId;
                            self.CustomerName = data.data.content.CustomerName;
                            self.orderResult = data.data.content.result;

                            self.formStatusId = data.data.content.CCAuthFormStatusId;
                            self.formStatus = data.data.content.CCAuthFormStatus;
                            self.formStatusName = data.data.content.CCAuthFormStatusName;


                            self.formStatusDt = data.data.content.CCAuthFormStatusDate;
                            self.creator = data.data.content.CCAuthFormCreatedBy;
                            self.created_at = data.data.content.CCAuthFormDateCreated;
                            self.modified = data.data.content.CCAuthFormModifiedBy;
                            self.modified_at = data.data.content.CCAuthFormDateModified;
                            self.reSubmitFlag = data.data.content.AllowResubmitFlag;
                            self.orderResult = data.data.content.result;

                            console.log("MAYUR === ",self.created_at);
                            var dateObject = new Date(self.created_at);
                            console.log("MAYUR === ",dateObject);


                            var today = new Date(self.created_at);
                            var dd = String(today.getDate()).padStart(2, '0');
                            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var yyyy = today.getFullYear();

                            today = mm + '/' + dd + '/' + yyyy;

                            if(self.reSubmitFlag == 1) {
                                $('#submitBtn').show();
                                /*
                                 2023-03-12: As per request received from Tim Chu we are changing the title of the "Resubmit" button to "New"
                                 Here on the Click on "New", we will Void the current form and create new form request.
                                 Reference email in Dev: Error In POS - 3rd Request
                                 $("#submitBtn").val("Resubmit");
                                 */
                                $("#submitBtn").val("New");
                                $("#saveBtn").hide();
                                $('#voidBtn').show();
                            } else {
                                $("#submitBtn").val("Submit");
                                $("#saveBtn").show();
                                $('#voidBtn').show();
                            }
                            $('#orderForm').show();
                            $('#formContainer').show();

                            if (self.orderResult == 0) {

                            } else {
                                if (self.NewRequestFlag == 1) {
                                    self.isDisable = false;
                                    $("#saveBtn").show();
                                    $("#submitBtn").show();
                                } else {
                                    self.isDisable = true;
                                    $("#saveBtn").hide();
                                    if(self.reSubmitFlag != 1) {
                                      $("#submitBtn").hide();
                                    } else {
                                        self.isDisable = false;
                                    }
                                    $('#voidBtn').show();
                                }

                            }
                            if(self.formStatus == null) {
                              $('#voidBtn').hide();
                            } else {
                              $('#voidBtn').show();
                            }
                            if(self.customerId){
                                self.cusId = self.customerId;
                                self.getCustomerDetail(true);
                            }
                        }
                    })
                    .catch(function (error) {
                        // console.log(error.response.data);
                        self.hideLoader();
                        $('#formContainer').hide();
                        $('#orderForm').hide();
                        $('#noDataOrderForm').hide();
                        $('#noCustomerDataFound').hide();
                        
                        self.error_msg_login = "";
                        self.orderIdBtn = "Submit";
                        self.disableorderIdBtn = false;
                        /*$('#loginbtn').text("Login");
                        $("#loginbtn").attr("disabled", false);*/
                        if (error.response.status == 0) {
                            self.error_msg_login = "Remote server can not be reachable";
                        } else {
                            if (error.response.data.message) {
                                self.error_msg_login = '<h4>' + error.response.data.message + '</h4>';
                                if(error.response.data.content.result == 4) {
                                    self.AccountType = error.response.data.content.AccountType;
                                    self.orderResult = 4;
                                }
                            }
                        }
                    })
            }

        },
        cancelOrderDetailForm: function () {
            $('#formContainer').hide();
            $('#orderForm').hide();
            $('#noDataOrderForm').hide();
            $('#noCustomerDataFound').hide();
        },
        getKeyValueByKeyColumn: function () {

          var fields = {
              keyColumn: 'CCAUTHFORMID',
          };

          HTTP.post("get/keyvalue", fields)
              .then(function (data) {
                console.log(data);
                  self.hideLoader();
                  // self.orderIdBtn = "Submit";
                  // self.disableorderIdBtn = false;

                  if (data.data.code == 200) {
                    self.addCCAuthForm(data.data.content.KeyValue, false);
                  }
              })
              .catch(function (error) {
                  console.log(error);
                  self.hideLoader();
                  $('#formContainer').hide();
                  $('#orderForm').hide();
                  $('#noDataOrderForm').hide();
                  $('#noCustomerDataFound').hide();
                  self.error_msg_login = "";
                  self.orderIdBtn = "Submit";
                  self.disableorderIdBtn = false;
                  /*$('#loginbtn').text("Login");
                  $("#loginbtn").attr("disabled", false);*/
                  if (error.response.status == 0) {
                      self.error_msg_login = "Remote server can not be reachable";
                  } else {
                      if (error.response.data.message) {
                          self.error_msg_login = error.response.data.message;
                      }
                  }
              })
        },
        addCCAuthForm: function (status, isNewButtonClick) {
            if(isNewButtonClick) {
                self.submitCCAuthForm(status, isNewButtonClick);
            } else {
                var strSlsId = self.orderId;
                strSlsId = strSlsId.toLowerCase();
                if(!strSlsId.includes(':') && (self.orderAmtTax == 0.00 || self.orderAmtTax == 0.0000)) {
                    self.$swal({
                        title: "Are you sure you want to submit?",
                        text: "If you have not updated the tax in the Excede order, click 'Cancel' and return to this form once tax is added",
                        type: "info",
                        showCancelButton: true,
                        confirmButtonText: "Yes",
                        cancelButtonText: "Cancel",
                        showCloseButton: true,
                        showLoaderOnConfirm: true,
                    }).then(result => {
                        if (result.value) {
                            self.submitCCAuthForm(status, isNewButtonClick);
                        }
                    });
                } else {
                    self.submitCCAuthForm(status, isNewButtonClick);
                }
            }
        },
        submitCCAuthForm: function (status, isNewButtonClick) {
            self.showLoader();
            self.orderIdBtn = "Submitting...";
            self.disableorderIdBtn = true;

            var fields = {
                accountType: self.AccountType,
                billCusId: self.BillCusId,
                branchId: self.branchId,
                customerId: self.customerId,
                email: self.email,
                invoiceSlsId: self.InvoiceSlsId,
                mainPhone: self.mainPhone,
                orderAmt: self.orderAmt,
                orderAmtTax: self.orderAmtTax,
                ccAuthFormId: self.ccAuthFormId,
                orderAmtEstimateFlag: self.OrderAmtEstimateFlag,
                orderId: self.orderId,
                formStatus: status,
                userId: self.userId,
                customerName: self.CustomerName,
            };

            console.log(fields);

            HTTP.post("add/ccauthformdata", fields)
                .then(function (data) {
                    console.log(data);
                    self.hideLoader();
                    self.orderIdBtn = "Submit";
                    self.disableorderIdBtn = false;

                    if (data.data.code == 200) {
                        if(isNewButtonClick) {
                            self.getOrderDetail(1);
                        } else {
                            self.getOrderDetail(0);
                        }

                    }
                })
                .catch(function (error) {
                    console.log(error);
                    self.hideLoader();
                    $('#formContainer').hide();
                    $('#orderForm').hide();
                    $('#noDataOrderForm').hide();
                    $('#noCustomerDataFound').hide();
                    self.error_msg_login = "";
                    self.orderIdBtn = "Submit";
                    self.disableorderIdBtn = false;
                    /*$('#loginbtn').text("Login");
                    $("#loginbtn").attr("disabled", false);*/
                    if (error.response.status == 0) {
                        self.error_msg_login = "Remote server can not be reachable";
                    } else {
                        if (error.response.data.message) {
                            self.error_msg_login = error.response.data.message;
                        }
                    }
                })
        },
        addOrderRequest: function (status) {

            console.log('addOrderRequest = ', status);

            // Checking if the "#submitBtn" title is "New", if it is "New" then call "Void" + "New" workflow.
            var isNewButtonClick = false;
            if($("#submitBtn").val() == "New") {
                status = "VOID";
                isNewButtonClick = true;
            }
            var error = false;
            self.error_msg_login = "";
            self.emailError = "";
            self.mainPhoneError = "";

            if (!self.email || self.email == null || self.email == "") {
                self.emailError = "The Email is required.";
                error = true;
            } else if (!self.validEmail(self.email)) {
                self.emailError = 'Please Enter Valid Email';
                error = true;
            }

            if (!self.mainPhone || self.mainPhone == null || self.mainPhone == "") {
                self.mainPhoneError = "The Phone number is required.";
                error = true;
            }

            // if (self.mainPhone.length < 14) {
            //     self.mainPhoneError = "The Phone number is required.";
            //     error = true;
            // }

            if (!error) {
               self.addCCAuthForm(status, isNewButtonClick);
            }
        },
        formatPrice(value) {
            return parseFloat(value).toFixed(2);
        },
        priceToApi(value) {
            return value;//.replace(".", ".");
        },
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        phoneValidate(mainPhone) {
          var x = mainPhone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
          return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        sendCashCustomerEmail() {
            var self = this;
            var fields = {
              email: self.emailCashCustomer,
              orderId: self.orderId,
              accountType: self.AccountType
            };

          HTTP.post("customer/email", fields)
              .then(function (data) {
                console.log(data);
                self.hideLoader();
                if (data.data.code == 200) {
                    alert(data.data.message);
                }
              })
              .catch(function (error) {
                  console.log(error);
                  self.hideLoader();                  
                  if (error.response.status == 0) {
                      alert(error.response.data.message);
                  } else {
                      if (error.response.data.message) {
                          alert(error.response.data.message);
                      }
                  }
              });
        }


    }
}
</script>

<style scoped>
.requiredstar{
    position: unset;
    display: inline-block;
  }
  .text-danger {
    font-size: 14px;
    line-height: 18px;
    display: block;
  }
  :root label.checkbox-bootstrap input[type=checkbox] + span.checkbox-placeholder{
    margin: 0 7px 0 -35px;
  }
  .page-header-top-container{
    float: none;
    width: auto;
  }
  .order-form .order-btn-container{
      margin-top:30px;
  }
  @media (max-width: 767px) {
    .app-sidebar-right{
      padding-left:0!important;
    }
    .admin-page-content {
      padding: 0;
    }
    .order-form .order-btn-container{
      margin-top:0;
      margin-bottom: 20px;
    }
    .order-footerbtn .btn{
        margin-left:0 !important;
    }
    .btn{
        padding: 0.3rem 0.6rem;
        font-size: 0.8rem;
    }
  }
  .fake-input { position: relative; }
  /*.fake-input input { border:none; background-color:#fff; display:block; width: 100%; box-sizing: border-box }*/
  .fake-input img { position: absolute; top: 10px; right: 10px }

  .form-bottom-set {margin-bottom: 0.5rem;}
  .customer-details .accordion .card-header .btn.collapsed .fa-angle-up:before{
      content: "\f107";
  }
</style>



// WEBPACK FOOTER //
// src/components/Order/Order.vue